<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
    </div>
    <div class="container">
      <b-card>
        <div class="row">
          <div class="col-lg-6 text-left">
            <h1>Organizations Search</h1>
            <b-input-group>
              <b-input id="filter" v-model="filter" placeholder="Search" />
              <b-button @click="searchList()" class="btn btn-secondary btn-search">Search</b-button>
            </b-input-group>
          </div>
          <div class="col-lg-6 text-right">
            <router-link class="radius btn btn-secondary mr-2" to="/partners/create">Create Organization</router-link>
            <b-button @click="downloadCSV()" :disabled="downloading" class="btn btn-white"><font-awesome-icon icon="download" /> Download CSV</b-button>
          </div>
        </div>
      </b-card>
    </div>
    <div class="container text-left">
      <div class="row justify-content-md-center">
        <div class="col-lg-12">
          <b-card>
            <div v-if="$store.state.organizations.sort.field" class="text-center mb-2 sort-wrapper">
              <span>
                Sorting By:
                <b>{{ sortField }}</b
                >, Sort Direction:
                <b>{{ $store.state.organizations.sort.direction === 'ASC' ? 'Ascending' : 'Descending' }}</b>
              </span>
            </div>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th @click="sort('name')">Name <font-awesome-icon icon="sort" /></th>
                  <th @click="sort('city')">City <font-awesome-icon icon="sort" /></th>
                  <th class="count">Event Count</th>
                  <th class="count">Location Count</th>
                  <th class="count">Member Count</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="org in $store.state.organizations.list" :key="org._id">
                  <td>
                    <router-link :to="{ name: 'org detail', params: { orgId: org._id } }">{{ org.name }}</router-link>
                  </td>
                  <td>{{ org.city }}</td>
                  <td class="count">{{ org.events ? org.events.length : 0 }}</td>
                  <td class="count">{{ org.locations ? org.locations.length : 0 }}</td>
                  <td class="count">{{ org.users ? org.users.length : 0 }}</td>
                  <td><router-link :to="{ name: 'org edit', params: { orgId: org._id } }" class="btn btn-secondary">Edit</router-link></td>
                </tr>
              </tbody>
            </table>
            <div class="pagination justify-content-end mt-5">
              <div class="total-count">Total Records: {{ $store.state.organizations.fullCount.toLocaleString() }}</div>
              <b-pagination
                v-if="$store.state.organizations.fullCount > 0"
                :value="$store.state.organizations.page.page"
                :total-rows="$store.state.organizations.fullCount"
                :per-page="$store.state.organizations.page.pageSize"
                :hide-ellipsis="true"
                @change="changePage"
              />
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BreadcrumbsHelper from '../../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  data() {
    return {
      isLoading: false,
      filter: '',
      sortField: '',
      displayMap: {
        name: 'Name',
        city: 'City',
        infoSource: 'Info Source',
      },
      downloading: false,
      Breadcrumbs: [
        {
          text: 'Dashboard',
          active: false,
          href: '/admin',
        },
        {
          text: 'Partners',
          active: true,
        },
        {
          text: 'Organizations',
          active: true,
        },
      ],
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.$store.dispatch('organizations/getOrgs');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  beforeDestroy() {
    this.$store.dispatch('organizations/resetFilter');
  },
  methods: {
    sort(field) {
      try {
        this.isLoading = true;
        this.$store.dispatch('organizations/sortOrgs', field);
        this.sortField = this.displayMap[this.$store.state.organizations.sort.field];
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async changePage(page) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('organizations/setPage', page);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    searchList() {
      try {
        this.isLoading = true;
        this.$store.dispatch('organizations/setFilter', this.filter);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async downloadCSV() {
      let url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/organizations?csv=true`;
      const st = this.$store.state.organizations;
      if (st.sort.field) {
        url += `&sorting=true&sortField=${st.sort.field}&sortDirection=${st.sort.direction}`;
      }
      if (st.filter && st.filter !== '') {
        url += `&filtering=true&filter=${st.filter}`;
      }

      try {
        document.body.style.cursor = 'wait';
        this.downloading = true;
        await axios({
          method: 'get',
          url,
          responseType: 'blob',
        }).then((response) => {
          const url2 = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url2;
          link.setAttribute('download', 'organizations.csv'); // or any other extension
          document.body.appendChild(link);
          link.click();
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.downloading = false;
        document.body.style.cursor = 'default';
      }
    },
    async changeInfoSource(org, checked) {
      try {
        await axios.post(`${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/organizations/${org._id}`, { infoSource: checked });

        this.$bvToast.toast(`Success updating info source for org: ${org.name}`, {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
        });
      } catch (err) {
        this.$bvToast.toast(`Error updating info source for org: ${org.name}`, {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
  },
};
</script>

<style scoped>
h1 {
  margin: 0px 0 20px 0;
}
th {
  cursor: pointer;
}
td.count,
th.count {
  text-align: center;
}
.total-count {
  padding: 0px 20px 0px 0px;
  line-height: 35px;
}
.card {
  border: none;
}
.sort-wrapper span {
  background-color: #f5ecca;
  padding: 5px 10px;
  border-radius: var(--rounded-md);
  margin-bottom: 5px;
  display: inline-block;
}
th.sort span {
  cursor: pointer;
}
.fa-sort {
  color: #ccc;
}
table thead th {
  white-space: nowrap;
}
</style>
